var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("403 Unauthorized")]),_c('p',[_vm._v(" The "),_c('em',[_vm._v(_vm._s(_vm.resource))]),_vm._v(" you're looking for is private, viewable by participating project members only. ")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home page with menu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }